var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showLoadingState < 2)?_c('div',{key:"loadingState"},[_c('AtomLoadingPrimary')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }